import PropTypes from 'prop-types'

const AddressFields = ({ formData, onChange, isLoading }) => (
  <>
    <div className="form-row">
      <div className="form-group">
        <label htmlFor="firstName">First Name</label>
        <input
          type="text"
          id="firstName"
          name="firstName"
          value={formData.firstName}
          onChange={onChange}
          placeholder="Enter first name"
          required
          disabled={isLoading}
        />
      </div>

      <div className="form-group">
        <label htmlFor="lastName">Last Name</label>
        <input
          type="text"
          id="lastName"
          name="lastName"
          value={formData.lastName}
          onChange={onChange}
          placeholder="Enter last name"
          required
          disabled={isLoading}
        />
      </div>
    </div>

    <div className="form-group">
      <label htmlFor="street">Street</label>
      <input
        type="text"
        id="street"
        name="street"
        value={formData.street}
        onChange={onChange}
        placeholder="Enter street address"
        required
        disabled={isLoading}
      />
    </div>

    <div className="form-row">
      <div className="form-group">
        <label htmlFor="postalCode">Postal Code</label>
        <input
          type="text"
          id="postalCode"
          name="postalCode"
          value={formData.postalCode}
          onChange={onChange}
          placeholder="Enter postal code"
          required
          disabled={isLoading}
        />
      </div>

      <div className="form-group">
        <label htmlFor="city">City</label>
        <input
          type="text"
          id="city"
          name="city"
          value={formData.city}
          onChange={onChange}
          placeholder="Enter city"
          required
          disabled={isLoading}
        />
      </div>
    </div>
  </>
)

AddressFields.propTypes = {
  formData: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    street: PropTypes.string.isRequired,
    postalCode: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
}

export default AddressFields
